import { DiagnosticsActionType } from "models/actionTypes/diagnosticsActionType";
import { ReduxConstants } from "utils/constants";

export const openedDefaultFAQArticle = (): DiagnosticsActionType => {
  return {
    type: ReduxConstants.DiagnosticsActions.OPENED_DEFAULT_FAQ_ARTICLE,
  };
};

export const wroteQuestion = (question: string): DiagnosticsActionType => {
  return {
    type: ReduxConstants.DiagnosticsActions.WROTE_QUESTION,
    payload: question,
  };
};

export const receivedRetrievedFAQArticles = (articleId: string[]): DiagnosticsActionType => {
  return {
    type: ReduxConstants.DiagnosticsActions.RECEIVED_RETRIEVED_FAQ_ARTICLE,
    payload: articleId,
  };
};

export const openedRetrievedFAQArticle = (articleId: string): DiagnosticsActionType => {
  return {
    type: ReduxConstants.DiagnosticsActions.OPENED_RETRIEVED_FAQ_ARTICLE,
    payload: articleId,
  };
};

export const clickedCreateSupportCase = (): DiagnosticsActionType => {
  return {
    type: ReduxConstants.DiagnosticsActions.CLICKED_CREATE_SUPPORT_CASE,
  };
};

export const openedCloseConfirmation = (): DiagnosticsActionType => {
  return {
    type: ReduxConstants.DiagnosticsActions.OPENED_CLOSE_CONFIRMATION,
  };
};

export const closedDialog = (): DiagnosticsActionType => {
  return {
    type: ReduxConstants.DiagnosticsActions.CLOSED_DIALOG,
  };
};

export const sentSupportCase = (): DiagnosticsActionType => {
  return {
    type: ReduxConstants.DiagnosticsActions.SENT_SUPPORT_CASE,
  };
};

export const resetFAQDiagnostics = (): DiagnosticsActionType => {
  return {
    type: ReduxConstants.DiagnosticsActions.RESET_FAQ_DIAGNOSTICS,
  };
};
